import { render } from "./PromptModal.vue?vue&type=template&id=069cb8b5&scoped=true"
import script from "./PromptModal.vue?vue&type=script&lang=js"
export * from "./PromptModal.vue?vue&type=script&lang=js"

import "./PromptModal.vue?vue&type=style&index=0&id=069cb8b5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069cb8b5"]])

export default __exports__